var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDatePicker",
    {
      attrs: {
        value: _vm.activityDateFormated,
        input: false,
        formatDateDisplayed: _vm.formatDateDisplayed,
        placement: _vm.placement,
        calendarOptions: _vm.calendarOptions,
        datePickerClass: "activities-reschedule-datepicker"
      },
      on: { "update:value": _vm.handleUpdateValue }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }